import { ModelSagres } from "../../model-sagres"

export class Permissao extends ModelSagres {
    Id: number
    Caminho: string
    Rota: string
    IdPerfil: number
    Perfil: string
    ApenasUg: boolean
}